import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * GET `/mom/work-order/{workOrderId}/amendment/{amendmentId}`。
 *
 * @param {string} workOrderId
 * @param {string} amendmentId
 */
export async function fetchWorkOrderAmendmentDetail(workOrderId, amendmentId) {
  const { data: raw } = await request.get(
    `/mom/work-order/${workOrderId}/amendment/${amendmentId}`,
  );
  return parseVer4DetailResponse(raw);
}
